import layout from '@/layout'

export default {
  path: '/log',
  component: layout,
  redirect: '/log/index',
  name: 'AdminLogs',
  meta: {
    title: '其他',
    icon: 'other'
  },
  children: [
    {
      path: '/config/log',
      name: 'AdminLog',
      component: () => import('@/views/system/admin_log/index'),
      meta: {
        title: '后台日志',
        icon: 'log'
      }
    },
    {
      path: '/user_register_apply/index',
      name: 'userRegisterApply',
      component: () => import('@/views/user_register_apply/index'),
      meta: {
        title: '注册申请',
        icon: 'log'
      }
    }
  ]
}
